import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ChallengeInterface, setEditId, setEditError, selectChallengeById } from "src/store/mine_craft/challengesSlice";
import { updateChallenge, fetchChallenge } from "src/actions/mine_craft/challengesActions";
import { objToFormData } from "src/helpers/FormHelper";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";
import moment from "moment/moment";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.challenges.editId);
  const error = useAppSelector(state => state.mineCraft.challenges.editError);
  const challenge = useAppSelector(state => id ? selectChallengeById(state, id) : undefined);
  const params: any = { ...challenge };
  params.range = [
    moment(challenge?.start_at).utc(),
    moment(challenge?.end_at).utc()
  ];

  useEffect(() => {
    if (id) {
      dispatch(fetchChallenge(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };
    delete data.range;

    data.start_at = rawData.range[0].toString();
    data.end_at   = rawData.range[1].toString();

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: ChallengeInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateChallenge({ id, data: formData }));

    if (updateChallenge.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-challenge'>
        <h6 className="v-content-label">Edit Challenge</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
